<template>
  <div class="badge">
    <div class="badge__title font-caps">
      <slot />
    </div>
    <div v-if="!!$slots.tooltip" class="badge__tooltip">
      <tooltip
        @show="$emit('tooltipShow', $event)"
        @apply-hide="$emit('tooltipHide', $event)"
      >
        <template #content>
          <slot name="tooltip" />
        </template>
      </tooltip>
    </div>
  </div>
</template>

<script>
import Tooltip from "@/components/ui-kit/tooltip/index.vue";

export default {
  components: {
    Tooltip,
  },
};
</script>

<style lang="scss" scoped>
.badge {
  display: inline-flex;
  align-items: center;
  vertical-align: top;
  padding: 0 7px;
  color: var.$secondary;
  border: 1px solid currentColor;
  border-radius: var.$rounded-4;

  &__title {
    padding: 5px 0;
    text-transform: uppercase;
  }

  &__tooltip {
    width: 14px;
    margin-right: -2px;
    margin-left: 6px;
  }
}
</style>
